// Kickoff prompt, reply parsing and recap: plain text only, so they test without the browser.
type Note = { name: string; reply: string | null; error?: string };

export function kickoffPrompt(title: string, brief: string) {
	return `Pioneer project kickoff: ${title}.\n\nProject brief:\n${brief}\n\n` +
		"You are on the kickoff agenda. Reply with at most three short lines and nothing else:\n" +
		"Take: up to three pieces of this project you would own, as one-line titles separated by semicolons.\n" +
		"Need: what you depend on, and from whom.\nRisk: the one thing most likely to go wrong.\n" +
		"Never take work that moves funds, signs transactions or changes keys; that belongs to the owner. Under 90 words.";
}
// Agents write "Take:", "**Take:**" or "- Take:"; anything else in the reply is ignored.
export function parseKickoff(text: string) {
	const line = (key: string) => (text.match(new RegExp("^[\\s*_-]*" + key + "[*_]*\\s*:[*_]*\\s*(.+)$", "im")) || [])[1]?.trim() || "";
	return { take: line("Take").split(/\s*;\s*/).filter(Boolean).slice(0, 3), need: line("Need"), risk: line("Risk") };
}
export function recap(title: string, notes: Note[]) {
	return [`Kickoff recap: ${title} (${new Date().toISOString().slice(0, 10)})`, ...notes.map((n) => {
		if (!n.reply) return `- ${n.name}: did not answer (${n.error}).`;
		const k = parseKickoff(n.reply);
		return `- ${n.name} takes: ${k.take.join("; ") || "nothing named"}. Needs: ${k.need || "nothing named"}. Risk: ${k.risk || "none named"}.`;
	}), "Scribe: file one ticket per piece, assigned to the agent who took it (SOP: Project Kickoff Meeting)."].join("\n");
}

